import React from 'react';
import usePagination from '../../hooks/use-pagination';

interface Props {
  onPageChange: (page) => void;
  totalCount: number;
  siblingCount: number;
  currentPage: number;
  pageSize: number;
}

const Pagination: React.FC<Props> = ({
  onPageChange,
  totalCount,
  siblingCount,
  currentPage,
  pageSize,
}) => {
  const paginationRange = usePagination(
    totalCount,
    pageSize,
    siblingCount,
    currentPage
  );

  // @ts-ignore
  if (currentPage === 0 || !paginationRange || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  // @ts-ignore
  const lastPage = paginationRange[paginationRange.length - 1];

  return (
    <React.Fragment>
      <ul className="pagination-container">
        <li
          className={
            currentPage === 1 ? 'pagination-item disabled' : 'pagination-item'
          }
          onClick={onPrevious}
        >
          <div className="arrow-left" />
        </li>
        {paginationRange?.map((pageNumber, index) => {
          if (pageNumber === '...') {
            return (
              <li className="pagination-item dots" key={index}>
                &#8230;
              </li>
            );
          }

          return (
            <li
              className={
                pageNumber === currentPage
                  ? 'pagination-item selected'
                  : 'pagination-item'
              }
              onClick={() => onPageChange(pageNumber)}
              key={index}
            >
              {pageNumber}
            </li>
          );
        })}
        <li
          className={
            currentPage === lastPage
              ? 'pagination-item disabled'
              : 'pagination-item'
          }
          onClick={onNext}
        >
          <div className="arrow-right" />
        </li>
      </ul>
      {/* language=CSS */}
      <style jsx>{`
        .pagination-container {
          display: flex;
          justify-content: center;
          list-style-type: none;
          margin: 2rem 0 1rem;
          padding: 0;
        }

        .pagination-item {
          padding: 0 12px;
          height: 32px;
          text-align: center;
          margin: auto 4px;
          color: rgba(0, 0, 0, 0.87);
          display: flex;
          box-sizing: border-box;
          align-items: center;
          letter-spacing: 0.01071em;
          border-radius: 16px;
          line-height: 1.43;
          font-size: 13px;
          min-width: 32px;
          font-family: 'Volvo Novum', sans-serif;
        }

        .pagination-item.dots:hover {
          background: transparent;
          cursor: default;
        }

        .pagination-item:hover {
          background: rgba(0, 0, 0, 0.04);
          cursor: pointer;
        }

        .pagination-item.selected {
          background: rgba(0, 0, 0, 0.08);
        }

        .arrow-left:before,
        .arrow-right:before {
          position: relative;
          content: '';
          display: inline-block;
          width: 0.4em;
          height: 0.4em;
          border-right: 0.12em solid rgba(0, 0, 0, 0.87);
          border-top: 0.12em solid rgba(0, 0, 0, 0.87);
        }

        .arrow-left {
          transform: rotate(-135deg) translate(-50%);
        }

        .arrow-right {
          transform: rotate(45deg);
        }

        .pagination-item.disabled {
          pointer-events: none;
        }

        .pagination-item.disabled .arrow-left:before,
        .pagination-item.disabled .arrow-right:before {
          border-right: 0.12em solid rgba(0, 0, 0, 0.43);
          border-top: 0.12em solid rgba(0, 0, 0, 0.43);
        }

        .pagination-item.disabled:hover {
          background: transparent;
          cursor: default;
        }
      `}</style>
    </React.Fragment>
  );
};

export default Pagination;
